import { createSlice } from "@reduxjs/toolkit";
import { updateProfileState, userDataState } from "../../state/index";

const getUserDataSlice = createSlice({
  name: "GET_USER_DATA_SLICE",
  initialState: userDataState,
  reducers: {
    startUserData: (state) => {
      state.userLoading = true;
      state.userError = null;
    },
    successUserData: (state, action) => {
      state.userLoading = false;
      state.user = action.payload.payload;
    },
    errorUserData: (state, action) => {
      state.userLoading = false;
      state.userError = action.payload;
    },
  },
});

const updateUserDataSlice = createSlice({
  name: "UPDATE_USER_DATA_SLICE",
  initialState: updateProfileState,
  reducers: {
    startUpdate: (state) => {
      state.loading = true;
      state.error = null;
    },
    successUpdate: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorUpdate: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetProfileUpdate: (state, action) => {
      state.loading = false;
      state.error = null;
      state.data = null;
    },
  },
});

export const { startUserData, successUserData, errorUserData } =
  getUserDataSlice.actions;
export const { startUpdate, successUpdate, errorUpdate, resetProfileUpdate } =
  updateUserDataSlice.actions;

export const getUserDataReducer = getUserDataSlice.reducer;
export const updateProfileReducer = updateUserDataSlice.reducer;
